import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { NextSeo } from "next-seo";

import Header from "../../Header";
import Footer from "../../Footer";
import SideMenu from "../../SideMenu";
import LastUpdate from "../../LastUpdate";
import { CardList } from "../../../src/components/molecules";
import { NavigationBar } from "../../../src/components/atoms";
import { useRouter } from "next/router";
import { Colors, Constants, Fonts, Values } from "../../../src/config";
import slugify from "slugify";
import moment from "moment";
import Head from "next/head";
import { FestivalDao } from "../../../src/DAO";
import {
  ActivityIndicator,
  StyleSheet,
  Text,
  TouchableOpacity,
} from "react-native-web";

const GuideYearType = (props) => {
  const { t } = useTranslation();
  const {
    categoryType,
    listDataCountry,
    listDataState,
    listDataCity,
    listDataFilter,
    listData,
    countListData,
    yearSelected,
    continentSelected,
    countrySelected,
    stateSelected,
    citySelected,
    typeSelected,
    paramsFinal,
  } = props;

  const router = useRouter();

  const [sideMenuShow, setSideMenuShow] = useState(false);
  const [sideMenuHeaderShow, setSideMenuHeaderShow] = useState(false);
  const [isMobileVersion, setIsMobileVersion] = useState(false);
  const [items, setItems] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [lastPageCount, setLastPageCount] = useState(0);
  const [pageIndex, setPageIndex] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const isShowLoadMore = items.length < totalCount;
  const countries = listDataCountry;
  const states = listDataState;
  const cities = listDataCity;
  const types = listDataFilter;
  const countryData = countries?.find(
    (i) => slugify(i.countryName?.toLowerCase()) === countrySelected
  );
  const stateData = states?.find(
    (i) =>
      slugify(i.stateName?.toLowerCase()) ===
      stateSelected?.replace("-state", "")
  );
  const cityData = cities?.find(
    (i) => slugify(i.cityName?.toLowerCase()) === citySelected
  );
  const typeData = types?.find(
    (i) =>
      slugify(i?.filterName?.toLowerCase()) ===
      typeSelected?.replace(
        `-${
          process.env.NEXT_PUBLIC_APP_NAME == "Vybeful"
            ? "clubs"
            : process.env.NEXT_PUBLIC_APP_NAME == "RooftopClub"
            ? "rooftops"
            : process.env.NEXT_PUBLIC_APP_NAME == "Cocktayl"
            ? "cocktail-bars"
            : process.env.NEXT_PUBLIC_APP_NAME == "SpaClub"
            ? "spas"
            : process.env.NEXT_PUBLIC_APP_NAME == "Beachful"
            ? "beach-clubs"
            : process.env.NEXT_PUBLIC_APP_NAME == "Festyful"
            ? "festivals"
            : "clubs"
        }`,
        ""
      )
  );
  const metaTitle = `${
    typeData &&
    typeData?.filterName !== "Pool" &&
    typeData?.filterName !== "Bar" &&
    typeData?.filterName !== "Restaurant"
      ? typeData?.filterName?.replace("All", "") + " "
      : ""
  }${
    process.env.NEXT_PUBLIC_APP_NAME == "Vybeful"
      ? "Clubs"
      : process.env.NEXT_PUBLIC_APP_NAME == "RooftopClub"
      ? typeData?.filterName === "Pool" ||
        typeData?.filterName === "Bar" ||
        typeData?.filterName === "Restaurant"
        ? "Rooftop"
        : "Rooftops"
      : process.env.NEXT_PUBLIC_APP_NAME == "Cocktayl"
      ? "Cocktail Bars"
      : process.env.NEXT_PUBLIC_APP_NAME == "SpaClub"
      ? "Spas"
      : process.env.NEXT_PUBLIC_APP_NAME == "Beachful"
      ? "Beach Clubs"
      : process.env.NEXT_PUBLIC_APP_NAME == "Festyful"
      ? "Festivals"
      : "Clubs"
  } ${
    typeData &&
    (typeData?.filterName === "Pool" ||
      typeData?.filterName === "Bar" ||
      typeData?.filterName === "Restaurant")
      ? typeData?.filterName?.replace("All", "") + "s "
      : ""
  }${cityData?.cityName || stateData?.stateName || countryData?.countryName}${
    yearSelected ? ` ${yearSelected}` : ""
  }`;
  const metaDescription = `Discover all the ${
    typeData &&
    typeData?.filterName !== "Pool" &&
    typeData?.filterName !== "Bar" &&
    typeData?.filterName !== "Restaurant"
      ? typeData?.filterName?.replace("All", "")?.toLowerCase() + " "
      : ""
  }${
    process.env.NEXT_PUBLIC_APP_NAME == "Vybeful"
      ? "clubs"
      : process.env.NEXT_PUBLIC_APP_NAME == "RooftopClub"
      ? typeData &&
        (typeData?.filterName === "Pool" ||
          typeData?.filterName === "Bar" ||
          typeData?.filterName === "Restaurant")
        ? "rooftop"
        : "rooftops"
      : process.env.NEXT_PUBLIC_APP_NAME == "Cocktayl"
      ? "cocktail bars"
      : process.env.NEXT_PUBLIC_APP_NAME == "SpaClub"
      ? "spas"
      : process.env.NEXT_PUBLIC_APP_NAME == "Beachful"
      ? "beach clubs"
      : process.env.NEXT_PUBLIC_APP_NAME == "Festyful"
      ? "festivals"
      : "clubs"
  } ${
    typeData &&
    (typeData?.filterName === "Pool" ||
      typeData?.filterName === "Bar" ||
      typeData?.filterName === "Restaurant")
      ? typeData?.filterName?.replace("All", "")?.toLowerCase() + "s "
      : ""
  }in ${
    cityData?.cityName || stateData?.stateName || countryData?.countryName
  } in ${yearSelected} with our guide.`;
  const updatedAt = moment().startOf("week").add("2", "days").toISOString();
  const canonicalURL = `https://${process.env.NEXT_PUBLIC_WWW_BASE_URL}/guides/${yearSelected}/${continentSelected}/${countrySelected}/${typeSelected}`;

  useEffect(() => {
    setIsMobileVersion(Values.deviceWidth < 640);
  }, [Values.deviceWidth]);

  const onLoad = async (page = 0) => {
    if (isLoading) return;
    setIsLoading(true);
    FestivalDao.findWeb({ ...paramsFinal, pageSize: 100, pageIndex: page })
      .then((result) => {
        if (page == 0) {
          setItems(result.data);
        } else {
          setItems([...items, ...result.data]);
        }
        setLastPageCount(result.data.length);
        setTotalCount(result.totalCount);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    onLoad();
  }, []);

  const onLoadMore = () => {
    if (lastPageCount == 100 && !isLoading) {
      setPageIndex(pageIndex + 1);
      onLoad(pageIndex + 1);
    }
  };

  return (
    <div>
      <Head>
        <script
          key="structured-data"
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "WebPage",
              "@id": canonicalURL,
              url: canonicalURL,
              name: metaTitle,
              dateModified: updatedAt,
            }),
          }}
        />
      </Head>
      <NextSeo
        title={`${metaTitle} - ${process.env.NEXT_PUBLIC_APP_NAME}`}
        description={metaDescription}
        canonical={canonicalURL}
        openGraph={{
          type: "website",
          locale: "en_EN",
          url: canonicalURL,
          title: `${metaTitle} - ${process.env.NEXT_PUBLIC_APP_NAME}`,
          description: metaDescription,
          images: [
            {
              url: `https://${process.env.NEXT_PUBLIC_WWW_BASE_URL}${process.env.NEXT_PUBLIC_BANNER_IMAGE}`,
              width: 1200,
              height: 630,
              alt: `${process.env.NEXT_PUBLIC_APP_NAME}${process.env.NEXT_PUBLIC_APP_SLOGAN}`,
              type: "image/png",
            },
          ],
          siteName: `${process.env.NEXT_PUBLIC_APP_NAME}${process.env.NEXT_PUBLIC_APP_SLOGAN}`,
        }}
      />
      <Header setSideMenuShow={setSideMenuShow} />

      <SideMenu
        sideMenuShow={sideMenuShow}
        setSideMenuShow={setSideMenuShow}
        sideMenuHeaderShow={sideMenuHeaderShow}
        setSideMenuHeaderShow={setSideMenuHeaderShow}
      />

      <div className="bg-black">
        <div
          className={`mx-auto relative ${
            isMobileVersion ? "" : "wrapper pt-[30px]"
          } pb-[130px]`}>
          <div className="max-w-1160px min-h-screen flex-1 mx-auto">
            <NavigationBar
              title={metaTitle}
              customStyle={{ marginTop: 0 }}
              isMobileVersion={isMobileVersion}
              onBackPressed={() =>
                router.push(
                  `/guides/${yearSelected}/${continentSelected}/${countrySelected}`
                )
              }
            />
            <div className="flex flex-row justify-center items-center">
              <div className="flex flex-col justify-center items-center border border-spliterLine px-[10px] py-[5px] rounded-full text-white font-regular sm:text-base text-xs text-center mb-[30px]">
                <div>
                  <span className="text-grayText2">{countListData}</span>
                  &nbsp;
                  {categoryType === Constants.categoryType.CATEGORY_VENUE ||
                  categoryType ===
                    Constants.categoryType.CATEGORY_VENUE_COCKTAIL
                    ? "Bars"
                    : categoryType === Constants.categoryType.CATEGORY_ROOFTOP
                    ? "Rooftops"
                    : categoryType === Constants.categoryType.CATEGORY_SPA
                    ? "Spas"
                    : categoryType ===
                      Constants.categoryType.CATEGORY_VENUE_BEACHFUL
                    ? "Beach Clubs"
                    : categoryType ===
                      Constants.categoryType.CATEGORY_PREFAB_COMPANY
                    ? "Companies"
                    : categoryType === Constants.categoryType.CATEGORY_PARKFUL
                    ? "Amusement Parks"
                    : categoryType === Constants.categoryType.CATEGORY_CASINO
                    ? "Casinos"
                    : categoryType === Constants.categoryType.CATEGORY_RESORT
                    ? "Resorts"
                    : categoryType ===
                      Constants.categoryType.CATEGORY_APARTHOTEL
                    ? "Aparthotels"
                    : categoryType === Constants.categoryType.CATEGORY_FESTIVAL
                    ? "Festivals"
                    : "Venues"}
                </div>
              </div>
            </div>
            <div>
              <CardList
                isChartsMode={false}
                isGuides={true}
                horizontal={false}
                gridView={false}
                items={items.length > 0 ? items : listData}
                category={categoryType}
                style={{ marginTop: 16 }}
                // onItemAction={({ type, item }) => onItemAction({ type, item })}
                isLoadingNextPage={false}
                isLoading={false}
                isExploreSearch
                isMobileVersion={isMobileVersion}
                gapHeight={0}
              />
            </div>
            <div className="flex flex-row items-center justify-center">
              {isShowLoadMore && !isLoading && (
                <TouchableOpacity
                  style={
                    isMobileVersion
                      ? styles.mobileLoadMoreButtonContainer
                      : styles.loadMoreButtonContainer
                  }
                  onPress={onLoadMore}>
                  <Text
                    style={[
                      styles.buttonText,
                      isMobileVersion && { fontSize: 12, lineHeight: 12 },
                    ]}>
                    VIEW MORE
                  </Text>
                </TouchableOpacity>
              )}
              {isShowLoadMore && isLoading && (
                <div className="mt-[20px]">
                  <ActivityIndicator />
                </div>
              )}
            </div>
            {listData.length > 0 && (
              <LastUpdate
                isMobileVersion={isMobileVersion}
                updatedAt={updatedAt}
                isGuide
              />
            )}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

const styles = StyleSheet.create({
  loadMoreButtonContainer: {
    width: 180,
    height: 40,
    borderWidth: 1,
    borderColor: Colors.spliterLine,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 20,
    alignSelf: "center",
    marginTop: 18,
  },
  mobileLoadMoreButtonContainer: {
    width: 120,
    height: 32,
    borderWidth: 1,
    borderColor: Colors.spliterLine,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 20,
    alignSelf: "center",
    marginTop: 18,
  },
  buttonText: {
    color: Colors.white,
    fontFamily: Fonts.primaryBold,
    fontSize: 16,
    textAlign: "center",
  },
});

export default GuideYearType;
